export const actions = {
  GET_INSPECTIONS_BY_FIRM_LIST: 'GET_INSPECTIONS_BY_FIRM_LIST',
  GET_INSPECTIONS_BY_FIRM_LIST_SUCCESS: 'GET_INSPECTIONS_BY_FIRM_LIST_SUCCESS',
  GET_INSPECTIONS_BY_FIRM_LIST_FAILURE: 'GET_INSPECTIONS_BY_FIRM_LIST_FAILURE',
  SET_INSPECTIONS_BY_FIRM_PAGE: 'SET_INSPECTIONS_BY_FIRM_PAGE',
};
